/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Advantage_CitationsInputs */

const en_why_listening_advantage_citations = /** @type {(inputs: Why_Listening_Advantage_CitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skips citations and footnotes`)
};

const es_why_listening_advantage_citations = /** @type {(inputs: Why_Listening_Advantage_CitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Omite citas y notas al pie`)
};

/**
* | output |
* | --- |
* | "Skips citations and footnotes" |
*
* @param {Why_Listening_Advantage_CitationsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_advantage_citations = /** @type {((inputs?: Why_Listening_Advantage_CitationsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Advantage_CitationsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_advantage_citations(inputs)
	return en_why_listening_advantage_citations(inputs)
});